export default __webpack_public_path__ + "static/media/pictogramBeaconATM40.280e5933.svg";